import { Switch as MUISwitch, SwitchProps } from '@mui/material';
import { useSwitchStyles } from './switch.styles';

export const Switch = (props: SwitchProps) => {
  const { sx: providedSx } = props;
  const { sx } = useSwitchStyles({ providedSx });

  return <MUISwitch {...props} sx={sx} />;
};
